import React, { useEffect } from "react";
import { useState, useRef } from "react";
import {
    Box, Typography, Chip, Button, IconButton, Grid, TextField,
    Stack, Popper, Grow, Paper, ClickAwayListener,
    Autocomplete,
    Link,
    Popover
} from "@mui/material";
import moment from "moment";
import TableComponent from "components/grid";
import StatusBadge from "components/badge/StatusBadge";
import CustomPagination from "components/CustomPagination";
import { LuRefreshCw } from "react-icons/lu";
import { MdOutlineFilterAlt } from "react-icons/md";
import Select from "react-select";
import { useLazyGetMyActionTrackerQuery} from "store/slices/apis/actionTrackerSlice";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import { useParams } from "react-router-dom";
import { DEFAULT_DATE_FORMAT } from "config";
import EditActionTracker from "view/actionTracker/editTracker";
import { actionCategories, actionDecisionVsOperational, actionPriority, actionSource, actionStatus } from "helpers/actionTrackerOptions";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import ViewActionTracker from "view/actionTracker/ViewActionTracker";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";

const DueDateCell = ({ row }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const allDates = row?.revisedDueDate
        ? [row?.dueDate, ...row?.revisedDueDateHistory]
        : [row?.dueDate];

    const lastTwoDates = allDates.slice(-2);
    const extraCount = allDates.length - lastTwoDates.length;

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    return (

        extraCount > 0 && (
            <>
                <IconButton size="small" onClick={handleOpen}>
                    <MoreHorizIcon fontSize="small" />
                </IconButton>

                <Popover
                    open={Boolean(anchorEl)}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                >
                    <Box sx={{ p: 1, gap: 0.5, flexWrap: "wrap" }}>
                        {allDates?.slice(0, -2).map((date, i) => (
                            <Box sx={{ width: '100%', m: 1 }}>
                                <Chip
                                    key={i}
                                    label={moment(date).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        textDecoration: "line-through",
                                        color: "#e51c1cff",
                                        backgroundColor: "#f5ccccff",
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "5px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                            </Box>
                        ))}
                    </Box>
                </Popover>
            </>
        )
    );
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
)

const getStatusColor = (data) => {
    if (!data) return "purple";

    const status = (data.status || "").toLowerCase();
    const dueDate = data.dueDate ? new Date(data.dueDate) : null;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (dueDate) dueDate.setHours(0, 0, 0, 0);


    // Case 1: In Progress & overdue
    if (status === "in progress" && dueDate && dueDate < today) {
        return { bg: "#FFD7D8", text: "#FF383C" };
    }

    // Case 2: In Progress & future due date
    if (status === "in progress" && dueDate && dueDate >= today) {
        return { bg: "orange", text: "white" };
    }

    // Case 3: Completed or Closed
    if (status === "completed" || status === "closed") {
        return { bg: "#E1FFBB", text: "#34A853" };
    }

    // Default
    return "purple";
};


const PendingActionTracker = ({ data = [] }) => {
    const { projectId } = useParams();

    const [loading, setLoading] = useState(false);
    const [isApplyFilter, setIsApplyFIlter] = React.useState(false);

    // sorting asc desc
    const [sortOrder, setSortOrder] = React.useState('desc');
    const [sortBy, setSortBy] = React.useState('createdDate');

    // page size
    const [pageNumber, setPageNumber] = React.useState(1);
    const [pageSize, setPageSize] = React.useState(10);

    const [open, setOpen] = useState(false);

    const [isViewTracker, setIsViewTracker] = useState(false);
    const [isEditTracker, setIsEditTracker] = useState(false);
    const [rowData, setRowData] = useState(false);
    const [actionContact, setActionContact] = useState([]);

    const anchorRef = useRef(null);
    const [filters, setFilters] = useState({
        // ProjectId: projectId,
        SortBy: sortBy,
        SortOrder: sortOrder,
        PageNumber: pageNumber,
        PageSize: pageSize,
        Status: 'In progress',
    });
    const [projectData, setProjectData] = useState([]);

    const [trigger, { data: actionTrackerList, isFetching }] = useLazyGetMyActionTrackerQuery();
    const projectListRes = useGetAllProjectsQuery();
    const contactListRes = useGetAllContactsQuery();

    useEffect(() => {
        if (projectListRes?.isSuccess) {
            setProjectData(
                projectListRes?.data?.data?.map(item => ({
                    value: item?.projectId,
                    label: item?.projectName
                }))
            );
        }
    }, [projectListRes])

    useEffect(() => {
        if (contactListRes?.isSuccess) {
            const contacts = contactListRes?.data?.data || [];
            setActionContact(mapAndSortAlphabetically(contacts, "name", "email"));
        }
    }, [contactListRes])

    const handleViewClick = (row) => {
        setIsViewTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            return newState;
        });
    }

    const handleEditTracker = (row) => {
        setIsEditTracker((prev) => {
            const newState = !prev;
            setRowData(newState ? row : null);
            if (!newState) {
                trigger(filters);
            }
            return newState;
        });
    }

    const isReturnedForCorrections = (row) =>
        row?.status?.toLowerCase() === "returned for corrections";

    const renderRowAction = (row) =>
        isReturnedForCorrections(row) ? (
            <Button
                variant="outlined"
                size="small"
                onClick={() => handleEditTracker(row)}
                sx={{
                    textTransform: "none",
                    borderRadius: "3px",
                    fontSize: "12px",
                    minWidth: "132px",
                    height: "30px",
                    px: 1.25,
                    whiteSpace: "nowrap"
                }}
            >
                Correct & Resubmit
            </Button>
        ) : (
            <Button
                variant="text"
                size="small"
                onClick={() => handleViewClick(row)}
                sx={{
                    textTransform: "none",
                    fontSize: "12px",
                    minWidth: "48px",
                    height: "30px",
                    px: 1,
                    whiteSpace: "nowrap"
                }}
            >
                View
            </Button>
        );

    useEffect(() => {
        trigger(filters);
    }, []);

    const handleToggle = () => {
        setOpen((prevOpen) => !prevOpen);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleDelete = (fieldName) => {
        setFilters(prev => ({
            ...prev,
            [fieldName]: ""
        }));

        const updatedFilters = {
            ...filters,
            [fieldName]: "",
            PageNumber: 1,
            PageSize: 10,
        };
        trigger(updatedFilters);

    }

    const handleSelectChange = (selectedOption, fieldName) => {

        setFilters((prev) => ({
            ...prev,
            [fieldName]: selectedOption || "",
        }));
    }

    const handleReset = () => {
        const resetFilters = {
            SortBy: sortBy,
            SortOrder: sortOrder,
            PageNumber: 1,
            PageSize: 10,
        };
        trigger(resetFilters);
        setIsApplyFIlter(false);
    };

    const handleApplyFilters = () => {
        trigger({ ...filters, PageNumber: 1 });
        setIsApplyFIlter(true);
        setOpen(false);
    };

    const handlePageChange = (newPage) => {
        setPageNumber(newPage);
        const updatedFilters = {
            ...filters,
            PageNumber: newPage,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const handlePageSizeChange = (newSize) => {
        setPageSize(newSize);
        setPageNumber(1);
        const updatedFilters = {
            ...filters,
            PageSize: newSize,
            PageNumber: 1,
        };
        setFilters(updatedFilters);
        trigger(updatedFilters);
    };

    const createSortHandler = (property) => {
        const isAsc = sortBy === property && sortOrder === 'asc';
        const updatedFilters = {
            ...filters,
            SortBy: property,
            SortOrder: isAsc ? 'desc' : 'asc'

        };
        setFilters(updatedFilters);
        setSortOrder(isAsc ? 'desc' : 'asc');
        setSortBy(property);
        trigger(updatedFilters);
    };

    const columns = [
        // {
        //     name: "",
        //     field: "actions",
        //     width: "10px",
        //     sticky: true,
        //     renderer: (row) => (
        //         <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        //             <IconButton
        //                 size="small"
        //                 onClick={(e) => handleMenuOpen(e, row)}
        //             >
        //                 <MoreVertIcon fontSize="small" />
        //             </IconButton>
        //         </Box>
        //     ),
        // },
        {
            name: "ID",
            field: "customId",
            width: "100px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Link
                        component="button"
                        onClick={() => handleViewClick(row)}
                    // sx={{
                    //     textAlign: 'justify'
                    // }}
                    >
                        {row?.customId}
                    </Link>
                    {/* <Typography
                        sx={{
                            fontSize: "16px",
                            fontWeight: 500,
                            fontFamily: "Outfit",
                            color: "#0A65E4",
                            maxWidth: "140px",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            cursor: "pointer",
                            borderBottom: '1px solid #0A65E4',

                        }}
                        onClick={() => handleViewClick(row)}
                    >
                        {row?.customId}
                    </Typography> */}
                </Box>
            )
        },
        {
            name: "Description",
            field: "description",
            width: "300px",
            sticky: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    {row?.description}
                </Box>
            ),
        },
        {
            name: "Project",
            field: "projectName",
            // width: "7%",
        },
        {
            name: "Category",
            field: "topic",
            // width: "45%",
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
                    <Box>
                        <Typography sx={{
                            fontSize: "16px", maxWidth: "250px", fontWeight: 500, fontFamily: "Outfit", color: "#433F5E", overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}>
                            {row?.topic}
                        </Typography>
                    </Box>
                </Box>
            ),
        },
        {
            name: 'Status',
            field: 'status',
            renderer: (row) => (
                <StatusBadge status={row.status} />
            )
        },
        {
            name: "Priority",
            field: "priority",
            // width: "7%",
        },
        {
            name: "Due Date",
            field: 'dueDate',
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                    {row?.revisedDueDate ?
                        <>
                            <DueDateCell row={row} />
                            {[row?.dueDate, ...row?.revisedDueDateHistory]?.slice(-2)?.map((val, ind, arr) => {
                                const isLast = ind === arr.length - 1;

                                return (
                                    <Chip
                                        key={ind}
                                        label={moment(val).format(DEFAULT_DATE_FORMAT)}
                                        sx={{
                                            textDecoration: isLast ? "none" : "line-through",
                                            color: isLast ? "#34A853" : "#e51c1cff",
                                            backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
                                            fontWeight: 500,
                                            height: "20px",
                                            borderRadius: "5px",
                                            padding: "2px 6px",
                                            fontFamily: "Outfit",
                                            fontSize: "12px",
                                            marginRight: "5px",
                                        }}
                                    />
                                );
                            })}
                        </>
                        :
                        <>
                            {moment(row?.dueDate).isValid() ?
                                <Chip
                                    label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
                                    sx={{
                                        // textDecoration: "line-through",
                                        color: getStatusColor(row).text,
                                        backgroundColor: getStatusColor(row).bg,
                                        fontWeight: 500,
                                        height: "20px",
                                        borderRadius: "5px",
                                        padding: "2px 6px",
                                        fontFamily: "Outfit",
                                        fontSize: "12px",
                                        marginRight: "5px",
                                    }}
                                />
                                : '-'
                            }

                        </>
                    }
                </Box>
            ),
            // renderer: (row) => ( 
            //     <>
            //         {row?.revisedDueDate ?
            //             <>
            //                 <Chip
            //                     label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
            //                     sx={{
            //                         textDecoration: "line-through",
            //                         color: "#e51c1cff",
            //                         backgroundColor: "#f5ccccff",
            //                         fontWeight: 500,
            //                         height: "20px",
            //                         borderRadius: "5px",
            //                         padding: "2px 6px",
            //                         fontFamily: "Outfit",
            //                         fontSize: "12px",
            //                         marginRight: "5px",
            //                     }}
            //                 />
            //                 {row?.revisedDueDateHistory?.map((val, ind, arr) => {
            //                     const isLast = ind === arr.length - 1;

            //                     return (
            //                         <Chip
            //                             key={ind}
            //                             label={moment(val).format(DEFAULT_DATE_FORMAT)}
            //                             sx={{
            //                                 textDecoration: isLast ? "none" : "line-through",
            //                                 color: isLast ? "#34A853" : "#e51c1cff",
            //                                 backgroundColor: isLast ? "#E1FFBB" : "#f5ccccff",
            //                                 fontWeight: 500,
            //                                 height: "20px",
            //                                 borderRadius: "5px",
            //                                 padding: "2px 6px",
            //                                 fontFamily: "Outfit",
            //                                 fontSize: "12px",
            //                                 marginRight: "5px",
            //                             }}
            //                         />
            //                     );
            //                 })}
            //             </>
            //             :
            //             <>
            //                 {moment(row?.dueDate).isValid() ?
            //                     <Chip
            //                         label={moment(row?.dueDate).format(DEFAULT_DATE_FORMAT)}
            //                         sx={{
            //                             // textDecoration: "line-through",
            //                             color: "#34A853",
            //                             backgroundColor: "#E1FFBB",
            //                             fontWeight: 500,
            //                             height: "20px",
            //                             borderRadius: "5px",
            //                             padding: "2px 6px",
            //                             fontFamily: "Outfit",
            //                             fontSize: "12px",
            //                             marginRight: "5px",
            //                         }}
            //                     />
            //                     : '-'
            //                 }

            //             </>
            //         }
            //     </>
            // ),
        },
        {
            name: "Comment",
            field: "lastComment",
            width: '300px',
            renderer: (row) => (
                <>
                    {row?.lastComment ? row?.lastComment : '-'}
                </>
            ),
        },
        {
            name: "Actions",
            field: "actions",
            width: "160px",
            stickyRight: true,
            renderer: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-start", minHeight: "32px" }}>
                    {renderRowAction(row)}
                </Box>
            )
        },
    ];

    return (
        <>
            <Grid size={12}>
                <Grid container>
                    <Grid size={{ md: 8, sm: 6 }}>
                        {isApplyFilter &&
                            <Stack direction="row" spacing={1}>
                                {filters?.ProjectId && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Project:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{projectData.find(opt => opt.value === filters?.ProjectId)?.label}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('ProjectId')}
                                    />
                                )}
                                {filters?.Topic && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Category:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Topic}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Topic')}
                                    />
                                )}
                                {filters?.DecisionVsOperational && (
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Decision Vs Operational:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.DecisionVsOperational}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('DecisionVsOperational')}
                                    />
                                )}
                                {filters?.Status &&
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Status:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Status}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Status')}
                                    />
                                }
                                {filters?.Source &&
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Source:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Source}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Source')}
                                    />
                                }
                                {filters?.Priority &&
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Priority:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{filters?.Priority}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('Priority')}
                                    />
                                }
                                {filters?.DueDateFrom &&
                                    <Chip
                                        label={
                                            <Typography variant="body2">
                                                <strong style={{ color: '#0E73F6' }}>Due Date:</strong>{" "}
                                                <span style={{ fontWeight: 400, color: "#6B7280" }}>{moment(filters?.DueDateFrom)?.format('DD-MM-YYYY')}</span>
                                            </Typography>
                                        }
                                        sx={{
                                            backgroundColor: "rgba(25, 118, 210, 0.08)",
                                            border: 0
                                        }}
                                        variant="outlined"
                                        onDelete={() => handleDelete('DueDateFrom')}
                                    />
                                }

                            </Stack>
                        }
                    </Grid>
                    <Grid size={{ md: 4, sm: 6 }}>
                        <Box
                            sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: 'end'
                                // borderLeft: "1px solid #E5E9EB",
                                // borderRight: "1px solid #E5E9EB",
                            }}
                        >
                            <IconButton
                                ref={anchorRef}
                                onClick={handleToggle}
                            >
                                <MdOutlineFilterAlt size={24} color="#48535B" />
                            </IconButton>
                            <Popper
                                open={open}
                                anchorEl={anchorRef.current}
                                placement="bottom-end"
                                transition
                                disablePortal={false}
                                sx={{ zIndex: 2000 }}
                                onClick={(e) => e.stopPropagation()}
                            >
                                {({ TransitionProps }) => (
                                    <Grow {...TransitionProps}>
                                        <Paper
                                            sx={{
                                                mt: 1,
                                                p: 2,
                                                borderRadius: 1,
                                                boxShadow: "0px 4px 20px rgba(7, 7, 7, 0.08)",
                                                width: 600,
                                            }}
                                        >
                                            <ClickAwayListener onClickAway={handleClose}>

                                                <Box>
                                                    {open && (
                                                        <Grid container spacing={2}>
                                                            <Grid size={{ xs: 12, md: 6 }}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Project</Typography>
                                                                <Select
                                                                    name="ProjectId"
                                                                    options={projectData}
                                                                    value={projectData.find(opt => opt.value === filters?.ProjectId) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "ProjectId")}
                                                                    placeholder="Select Project"
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Category</Typography>
                                                                <Select
                                                                    name="topic"
                                                                    options={actionCategories}
                                                                    value={actionCategories.find(opt => opt.value === filters?.Topic) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "Topic")}
                                                                    placeholder="Select Category"
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>
                                                                    Select Decision Vs Operational
                                                                </Typography>
                                                                <Select
                                                                    name="decisionVsOperational"
                                                                    options={actionDecisionVsOperational}
                                                                    value={actionDecisionVsOperational.find(opt => opt.value === filters?.DecisionVsOperational) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "DecisionVsOperational")}
                                                                    // onBlur={() => setFieldTouched("decisionVsOperational", true)}
                                                                    placeholder="Select Decision Vs Operational"
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Priority</Typography>
                                                                <Select
                                                                    name="Priority"
                                                                    options={actionPriority}
                                                                    value={actionPriority.find(opt => opt.value === filters.Priority) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "Priority")}
                                                                    placeholder="Select Priority"
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Source</Typography>
                                                                <Select
                                                                    name="Source"
                                                                    options={actionSource}
                                                                    value={actionSource.find(opt => opt.value === filters.Source) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "Source")}
                                                                    placeholder="Select Source"
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Select Status</Typography>
                                                                <Select
                                                                    name="status"
                                                                    placeholder="Select Status"
                                                                    value={actionStatus.find(opt => opt.value === filters?.Status) || null}
                                                                    onChange={(option) => handleSelectChange(option?.value, "Status")}
                                                                    options={actionStatus}
                                                                />
                                                            </Grid>
                                                            <Grid size={6}>
                                                                <Typography sx={{
                                                                    fontFamily: 'Outfit',
                                                                    fontWeight: 500,
                                                                    fontSize: '16px',
                                                                    lineHeight: '100%',
                                                                    letterSpacing: "0px",
                                                                    mb: 1
                                                                }}>Due Date</Typography>
                                                                <TextField
                                                                    type="date"
                                                                    name="due_date"
                                                                    value={filters?.DueDateFrom}
                                                                    // onBlur={handleBlur}
                                                                    onChange={(e) => {
                                                                        const selectedDate = e.target.value;

                                                                        setFilters((prev) => ({
                                                                            ...prev,
                                                                            DueDateFrom: selectedDate,
                                                                        }));
                                                                    }}
                                                                    onClick={(e) => {
                                                                        // Trigger the native date picker
                                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                                        if (input) input.showPicker?.();
                                                                    }}
                                                                    fullWidth
                                                                    sx={{
                                                                        // ...rightTextStyle,
                                                                        "& input::-webkit-calendar-picker-indicator": {
                                                                            display: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& input[type='date']": {
                                                                            appearance: "none",
                                                                            WebkitAppearance: "none",
                                                                        },
                                                                        "& .MuiOutlinedInput-root": {
                                                                            "& fieldset": {
                                                                                border: "none",
                                                                            },
                                                                        },
                                                                    }}
                                                                    InputProps={{
                                                                        startAdornment: (
                                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}

                                                                            >
                                                                                {calenderSVG}
                                                                            </Box>
                                                                        ),
                                                                        sx: {
                                                                            backgroundColor: "#E7E7EB",
                                                                            height: "40px",
                                                                            width: { xs: "100%", md: "100%" },
                                                                            borderRadius: "5px",
                                                                        },
                                                                    }}
                                                                />
                                                            </Grid>

                                                            <Grid size={12}>
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        justifyContent: "flex-end",
                                                                        alignItems: "center",
                                                                    }}
                                                                >
                                                                    {isApplyFilter &&
                                                                        <Button onClick={handleReset}
                                                                            sx={{
                                                                                textTransform: "none",
                                                                                color: "#F15744",
                                                                                fontSize: "14px",
                                                                                lineHeight: "100%",
                                                                                fontFamily: "Outfit, sans-serif",
                                                                                borderRadius: "25px",
                                                                                fontWeight: 500,
                                                                                px: "20px",
                                                                                py: "15px",
                                                                            }}>
                                                                            Reset
                                                                        </Button>
                                                                    }

                                                                    <Button
                                                                        type="button"
                                                                        onClick={handleApplyFilters}
                                                                        variant="contained"
                                                                        sx={{
                                                                            backgroundColor: "#00344C",
                                                                            borderRadius: "25px",
                                                                            textTransform: "none",
                                                                            fontWeight: 500,
                                                                            fontSize: "14px",
                                                                            lineHeight: "100%",
                                                                            fontFamily: "Outfit, sans-serif",
                                                                            color: "#FFFFFF",
                                                                            px: "20px",
                                                                            py: "15px",
                                                                        }}
                                                                    >
                                                                        Apply
                                                                    </Button>
                                                                </Box>
                                                            </Grid>
                                                        </Grid>
                                                    )}
                                                </Box>
                                            </ClickAwayListener>
                                        </Paper>
                                    </Grow>
                                )}
                            </Popper>
                            {/* <IconButton>
                                    <BiListUl size={24} color="#48535B" />
                                </IconButton>
                                <IconButton>
                                    <MdOutlineFileDownload size={24} color="#48535B" />
                                </IconButton> */}
                            <IconButton>
                                <LuRefreshCw size={20} color="#48535B" />
                            </IconButton>
                        </Box>
                    </Grid>
                    <Grid size={12}>
                        <TableComponent
                            data={actionTrackerList?.data}
                            isLoading={loading}
                            columns={columns}
                            order={sortOrder}
                            orderBy={sortBy}
                            createSortHandler={createSortHandler}
                        />
                    </Grid>
                    <Grid size={12}>
                        <CustomPagination
                            totalCount={actionTrackerList?.totalRecords || 0}
                            pageSize={pageSize}
                            page={pageNumber}
                            onPageChange={handlePageChange}
                            setCurrentPage={setPageNumber}
                            onPageSizeChange={handlePageSizeChange}
                        />
                    </Grid>
                </Grid>
            </Grid>
            {
                isViewTracker &&
                <ViewActionTracker open={isViewTracker} handleClose={handleViewClick} rowData={rowData}/>
                // <ActionTrackerWorkflow open={isViewTracker} handleClose={handleViewClick} rowData={rowData} />
            }
            {
                isEditTracker &&
                <EditActionTracker open={isEditTracker} handleClose={handleEditTracker} rowData={rowData} actionContact={actionContact} mainTabValue={0} tabLength={1} />
            }
        </>
    );
}

export default PendingActionTracker;
